<template>
    <div class="wrapper">
         <div class="top">
            <h1 class="title">
                <span>Contact Information</span>
                <!-- <p class='guide'>Step <em>{{ $route.query.step }}</em> / {{ $route.query.as }}</p> -->
            </h1> 
            
        </div>       
        
        <ContactElement
            title="Urgent Contact"
            :choices="parents"
            :is_show = "data['one'].is_show"
            :data = "data['one']"
            key_name="one"
            fromPage="contact_page"
            :requestId="requestId"
            @setValue="setValue"
            @refreshRequestId="refreshRequestId"
            @setCount="setCount"
        ></ContactElement>
        <ContactElement
            title="Urgent Contact"
            :choices="brothers"
            :is_show = "data['two'].is_show"
            :data = "data['two']"
            fromPage="contact_page"
            :requestId="requestId"
            key_name="two"
            @setValue="setValue"
            @refreshRequestId="refreshRequestId"
            @setCount="setCount"
        ></ContactElement>
        <ContactElement
            title="Urgent Contact"
            :choices="friends"
            :is_show = "data['third'].is_show"
            :data = "data['third']"
            key_name="third"
            fromPage="contact_page"
            :requestId="requestId"
            @setValue="setValue"
            @refreshRequestId="refreshRequestId"
            @setCount="setCount"
        ></ContactElement>
        <div class="placeholder"></div>
        <div class="btn-container">            
            <a class='btn-submit' @click.prevent="submit">FINISH TO APPLY</a>
        </div>
    </div>
    
</template>
<script>
import ContactElement from '@/components/business/kyc/contact_element.vue'
import { submit_contact } from '@api/index'
import { v4 as uuidv4} from 'uuid'

export default {
    components:{
        ContactElement
    },
    data () {
        return {
            data:{
                "one":{
                    "name":{
                        value:"",
                        error:false,
                        errorText:"Please input 1th contact name"
                    },
                    "mobile":{
                        value:"",
                        error:false,
                        errorText:"Please input 1th contact phone number"
                    },
                    "relation":{
                        value:"",
                        error:false,
                        errorText:"Please indicate 1th contact relationship"
                    },
                    "is_show":false
                },
                "two":{
                    "name":{
                        value:"",
                        error:false,
                        errorText:"Please input 2th contact name"
                    },
                    "mobile":{
                        value:"",
                        error:false,
                        errorText:"Please input 2th contact phone number"
                    },
                    "relation":{
                        value:"",
                        error:false,
                        errorText:"Please indicate 2th contact relationship"
                    },
                    "is_show":false
                },
                "third":{
                    "name":{
                        value:"",
                        error:false,
                        errorText:"Please input 3th contact name"
                    },
                    "mobile":{
                        value:"",
                        error:false,
                        errorText:"Please input 3th contact phone number"
                    },
                    "relation":{
                        value:"",
                        error:false,
                        errorText:"Please indicate 3th contact relationship"
                    },
                    "is_show":false
                }
            },
            parents:[],
            brothers:[],
            friends:[],
            clicked:false,
            requestId:uuidv4()
        }
    },
    methods: {
        refreshRequestId(){
            this.requestId = uuidv4()
        },
        setCount(obj_name,key_name,v) {
            this.data[obj_name][key_name]['eventCount'] = v
        },
        setValue(obj_name,key_name,v) {
            if(typeof (this.data[obj_name][key_name].value) != 'undefined'){
                this.data[obj_name][key_name].value = v 
                this.data[obj_name][key_name].error = false
            } else {
                this.data[obj_name][key_name] = v
            }
            
        },
        validate () {
            let res = true
            let  text = ""
            let count = 0
            for(let x in this.data) {
                for(let y in this.data[x]) {
                    if(y=='is_show')continue
                    if(this.data[x][y].value === '') {
                        this.data[x][y].error = true
                        text += this.data[x][y]['errorText'] + "<br>"
                        count += 1
                        res = false                    
                    }
                }
            }               
            if(count > 2) {
                text = "In order to apply for a loan, please complete the emergency contact information."
                this.$toast.show(text)         
            } else if (count > 0) {
                this.$toast.show(text)         
            }
            
            return res
        },
        submit () {
            if(this.validate() && !this.clicked) {
                this.clicked = true
                const loader = this.$loading.show({
                    container: null
                })
                this.$store.dispatch("bury", {"event_id":"contact_page_enter_button_click"})
                submit_contact({
                    "oneName":this.data['one'].name.value,
                    "oneMobile": this.data['one'].mobile.value,
                    "oneRelation":this.data['one'].relation.value,
                    "twoName":this.data['two'].name.value,
                    "twoMobile": this.data['two'].mobile.value,
                    "twoRelation":this.data['two'].relation.value,
                    "thirdName":this.data['third'].name.value,
                    "thirdMobile": this.data['third'].mobile.value,
                    "thirdRelation":this.data['third'].relation.value,
                }).then((res)=>{                    
                    if(res.code == 0) {
                        this.$store.dispatch("bury", {"event_id":"contact_page_enter_button_click_success"})
                        this.$store.dispatch("uploadBury")
                        this.$router.replace({
                            "path":"/auth/index",
                            "query":{
                                "pid":this.$route.query.pid
                            }
                        })
                    } else {
                        let error_text = ""
                        for(let i = 0 ; i<res.data.errorColumn.length;i++) {
                            error_text += `${i+1}.  ${res.data.errorColumn[i].msg} \n`
                        }
                        this.$toast.show(error_text)
                        this.$store.dispatch("bury", {"event_id":"contact_page_enter_button_click_success",message:error_text })
                    }
                    loader.hide()
                    this.clicked = false
                })    
            }
        }
    },
    beforeMount() {
        this.$store.dispatch("bury", {"event_id":"contact_page_view"})
        this.$store.dispatch("clearBuryCache", [])
    },
    beforeUnmount () {
        this.$store.dispatch("bury", {"event_id":"contact_page_exit_page_tech"})
        this.$store.dispatch("clearBuryCache", [])
    },
    mounted () {
        document.body.style.background = "#F7F7F7"
        document.documentElement.scrollTop = 0
        let data = {
                "code": 0,
                "msg": "Success",
                "requestId": "1093dfa7-ab1f-4b7b-9df8-f794e73e2bc0",
                "data": [
                    {
                        "key": "Relation",
                        "label": "",
                        "value": "oneRelation",
                        "dataType": "0",
                        "checkType": "0",
                        "lengthLimitMin": 0,
                        "lengthLimitMax": 100,
                        "checkReq": 0,
                        "identifyValue": null,
                        "modifyValue": null,
                        "dictionaryVoList": [
                            {
                                "dictLabel": "Spouse",
                                "dictValue": "3",
                                "dictType": "oneRelation"
                            },
                            {
                                "dictLabel": "Mother",
                                "dictValue": "2",
                                "dictType": "oneRelation"
                            },
                            {
                                "dictLabel": "Father",
                                "dictValue": "1",
                                "dictType": "oneRelation"
                            }
                        ]
                    },
                    {
                        "key": "Friends",
                        "label": "",
                        "value": "thirdRelation",
                        "dataType": "0",
                        "checkType": "0",
                        "lengthLimitMin": 0,
                        "lengthLimitMax": 100,
                        "checkReq": 0,
                        "identifyValue": null,
                        "modifyValue": null,
                        "dictionaryVoList": [
                            {
                                "dictLabel": "Classmates",
                                "dictValue": "1",
                                "dictType": "thirdRelation"
                            },
                            {
                                "dictLabel": "Colleagues",
                                "dictValue": "2",
                                "dictType": "thirdRelation"
                            },
                            {
                                "dictLabel": "Friends",
                                "dictValue": "3",
                                "dictType": "thirdRelation"
                            }
                        ]
                    },
                    {
                        "key": "Relation",
                        "label": "",
                        "value": "twoRelation",
                        "dataType": "0",
                        "checkType": "0",
                        "lengthLimitMin": 0,
                        "lengthLimitMax": 100,
                        "checkReq": 0,
                        "identifyValue": null,
                        "modifyValue": null,
                        "dictionaryVoList": [
                            {
                                "dictLabel": "Children",
                                "dictValue": "3",
                                "dictType": "twoRelation"
                            },
                            {
                                "dictLabel": "sisters",
                                "dictValue": "2",
                                "dictType": "twoRelation"
                            },
                            {
                                "dictLabel": "brother",
                                "dictValue": "1",
                                "dictType": "twoRelation"
                            }
                        ]
                    }
                ],
                "isIntercept": null,
                "interceptConfig": null
            }
        this.parents = data.data[0].dictionaryVoList
        this.brothers = data.data[2].dictionaryVoList
        this.friends = data.data[1].dictionaryVoList
    
    }
}
</script>
<style lang="less" scoped>
    .wrapper{
        padding:20px 40px 40px;
        // .top{
        //     display:flex;
        //     justify-content: space-between;
        //     align-items: center;
        // }
        .title{
            display: flex;
            justify-content: space-between;
            align-items: center;
            color:#FF3470;
            font-size: 40px;
            margin: 0 0 50px 0;  
            .guide{
                color:#A59BB3;
                font-size: 30px;
                em{
                    color:#FF3470;
                    font-weight: 700;
                }
            }
        }
    }
    .caption{
        background:#E3D4FC;
        font-size: 26px;
        padding:15px;
        margin-bottom: 30px;
        line-height: 1.5;
        color:#FF3470;
        border-radius: 18px;
    }
    .btn-container{
        position: fixed;
        left:0;
        bottom: 0;        
        background:#fff;
        padding:40px;
        // padding:40px;
        .btn-submit{
            display: block;
            width: 670px;
            height: 96px;
            line-height: 96px;
            text-align: center;
            border-radius: 12px;
            background:#FF3470;
            font-size: 32px;
            margin:0 auto;
            color:#fff;
        }
    }
    .placeholder{
        height: 176px;        
    }
</style>